import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom"; // react-router-dom v5
import { FaConciergeBell, FaDownload, FaUserFriends } from "react-icons/fa";
import axios from "axios"; // 1. Import Axios
import menuData from "./MenuData";

const MenuDetails = () => {
  const { id } = useParams();
  const history = useHistory();

  // States
  const [persons, setPersons] = useState(500);
  const [showPopup, setShowPopup] = useState(false);
  const [userName, setUserName] = useState("");
  const [mobile, setMobile] = useState("");
  const [downloading, setDownloading] = useState(false);

  // Find menu
  const menu = menuData.find((m) => m.id === Number(id));

  // Auto-set the 'persons' state if the default (500) isn't available for this menu
  useEffect(() => {
    if (menu && !menu.prices[persons]) {
      const availableKeys = Object.keys(menu.prices);
      setPersons(Number(availableKeys[0]));
    }
  }, [menu]);

  if (!menu) return <div className="container py-5">Menu not found</div>;

  // Optimized getPrice to use the actual selected key
  const getPrice = () => {
    return menu.prices[persons] || "N/A";
  };

  const closePopup = () => {
    setShowPopup(false);
    setUserName("");
    setMobile("");
  };

  // --- MERGED API & DOWNLOAD LOGIC ---
  const handleDownload = async () => {

    const menuFiles = {
      1: "/menus/menu1.pdf",
      2: "/menus/menu2.pdf",
      3: "/menus/menu3.pdf",
      4: "/menus/menu4.pdf",
      5: "/menus/menu5.pdf",
      6: "/menus/menu6.pdf",
      7: "/menus/menu7.pdf",
    };

    const fileUrl = menuFiles[id];
    if (fileUrl) {
      if (!fileUrl) {
        alert("Menu PDF not found!");
        return;
      }
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    closePopup();
    alert("Menu Downloaded!");
  };

  return (
    <>
      <div className="menu-paper">

        <div className="menu-header-row">
          <div className="header-left">
            <button className="view-main-menu-btn" onClick={() => history.push("/menu")}>
              View Main Menu
            </button>
          </div>

          <div className="header-center">
            <img src="/assets/img/logo/1.png" alt="Logo" className="menu-logo" />
          </div>


          <div className="header-right">
            <div className="veg-icon-container">
              <div className="veg-border">
                <div className="veg-circle"></div>
              </div>
            </div>
          </div>
        </div>
        <h1 className="menu-title">{menu.title}</h1>
        <p className="menu-subtitle">{menu.description}</p>

        <div className="menu-meta-modern">
          <div className="guest-options-container">
            <p className="label">Select Guest Count to see Price:</p>
            <div className="guest-chips">
              {Object.keys(menu.prices)
                .sort((a, b) => Number(a) - Number(b))
                .map((count) => (
                  <button
                    key={count}
                    className={`chip ${Number(persons) === Number(count) ? 'active' : ''}`}
                    onClick={() => setPersons(Number(count))}
                  >
                    <span className="count">{count}+</span>
                    <span className="subtext">Guests</span>
                  </button>
                ))}
            </div>
          </div>

          <div className="final-price-box">
            <div className="price-tag">
              <span className="currency">₹</span>
              <span className="amount">{getPrice()}</span>
              <span className="per-plate">/ plate</span>
            </div>
            <p className="hint-text">Special pricing for {persons}+ guests</p>
          </div>
        </div>

        <div className="menu-divider">
          <span className="divider-icon"><FaConciergeBell /></span>
          <span className="divider-text">MENU</span>
          <span className="divider-icon"><FaConciergeBell /></span>
        </div>

        <ul className="ist">
          {menu.items.map((item, index) => (
            <li key={index}>
              <span className="menu-item-name">{item}</span>
            </li>
          ))}
        </ul>

        <button
          type="button"
          className="menu-download-btn"
          onClick={handleDownload}
        >
          <FaDownload /> Download Menu
        </button>

        {/* --- Notices Section --- */}
        <div className="menu-notices-container">
          <div className="notice-divider"></div>
          <ul className="notice-list">
            <li>• VIP વેઈટર્સ, PRO Service, Tables, Display Counters અને Transportation એકસ્ટ્રા લાગશે.</li>
            <li>• કચરાનો નિકાલ પાર્ટીએ જાતે કરવાનો રહેશે.</li>
            <li>• <strong>Payment Conditions:</strong> 25% Booking + 50% Before 1 Month + 25% Loading Date.</li>
            <li>• શરતોને આધીન.</li>
          </ul>
        </div>

      </div>

      {/* {showPopup && (
        <div className="menu-popup-overlay" onClick={closePopup}>
          <div className="menu-popup" onClick={(e) => e.stopPropagation()}>
            <h3>Download Menu</h3>
            <input
              type="text"
              placeholder="Your Name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <input
              type="tel"
              placeholder="Mobile Number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
            />
            <div className="popup-actions">
              <button onClick={closePopup}>Cancel</button>
              <button onClick={handleDownload}>Submit & Download</button>
            </div>
          </div>
        </div>
      )} */}

      {downloading && (
        <div className="download-overlay">
          <div className="spinner"></div>
          <p>Connecting to server...</p>
        </div>
      )}
    </>
  );
};

export default MenuDetails;